import React, { useState } from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
} from 'reactstrap';

const CustomerModal = ({ modal, toggle, onButtonClick }) => {
  const [email, setEmail] = useState();

  const handleClick = (e) => {
    e.preventDefault();
    if (email) {
      onButtonClick(email);
      toggle();
    }
  };

  return (
    <Modal isOpen={modal} toggle={toggle}>
      <ModalHeader toggle={toggle}>Fill customer email to link photo book</ModalHeader>
      <ModalBody>
        <Input
          type="text"
          placeholder="Customer email address"
          value={email}
          onChange={({ target: { value } }) => setEmail(value)}
        />
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleClick}>
          Link Photo Book
        </Button>
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export { CustomerModal };



// WEBPACK FOOTER //
// ./src/components/sav-lovebox/modal/customer-modal.js